import { Helmet } from "react-helmet";
import mainclasses from "../style.module.css";
import homeClasses from "./About.module.css";

const About = (props) => {
  return (
    <>
      <Helmet>
        <title>Sapid Books</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="description"
          content="Powerful Accounting Platform For Our Business"
        />
      </Helmet>
      <div className="container-fluid mt-5">
        <div className="row">
          <div className="col-md-8 mx-auto text-center">
            <h2 className={mainclasses.heading}>About Us-SapidBooks</h2>
            <img
              src={process.env.PUBLIC_URL + "/images/border.png"}
              alt="" id="b-img" style={{ width: "38%" }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-10 mx-auto">
            <div className="row">
              <div className="col-lg-5 mt-4 shadow p-2">
                <img
                  src={process.env.PUBLIC_URL + "/images/about.jpg"}
                  alt=""
                  className={homeClasses.banner}
                />
              </div>
              <div className="col-lg-1"></div>
              <div className="col-lg-6 mt-5 p-4">
                <p className={homeClasses.para}>
                  Welcome to SapidBooks, your premier destination for innovative
                  accounting solutions tailored to your business needs. We are
                  dedicated to transforming the way you manage your finances,
                  empowering you with the tools to streamline your accounting
                  processes and make informed decisions.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row"></div>
        <div className="container mt-5 p-4 bg-aliceblue">
          <div className="row">
            <div className="col-md-4 col-12 col-lg-4">
              <center><span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                >
                  <path
                    d="M23.75 35C23.75 35.3315 23.6183 35.6495 23.3839 35.8839C23.1495 36.1183 22.8315 36.25 22.5 36.25H17.5C17.1685 36.25 16.8505 36.1183 16.6161 35.8839C16.3817 35.6495 16.25 35.3315 16.25 35C16.25 34.6685 16.3817 34.3505 16.6161 34.1161C16.8505 33.8817 17.1685 33.75 17.5 33.75H22.5C22.8315 33.75 23.1495 33.8817 23.3839 34.1161C23.6183 34.3505 23.75 34.6685 23.75 35ZM20 17.5C20.3708 17.5 20.7333 17.39 21.0417 17.184C21.35 16.978 21.5904 16.6851 21.7323 16.3425C21.8742 15.9999 21.9113 15.6229 21.839 15.2592C21.7666 14.8955 21.588 14.5614 21.3258 14.2992C21.0636 14.0369 20.7295 13.8584 20.3658 13.786C20.0021 13.7137 19.6251 13.7508 19.2825 13.8927C18.9399 14.0346 18.647 14.275 18.441 14.5833C18.235 14.8916 18.125 15.2542 18.125 15.625C18.125 16.1223 18.3225 16.5992 18.6742 16.9508C19.0258 17.3025 19.5027 17.5 20 17.5ZM34.9406 24.3484L33.0094 33.0406C32.9177 33.4534 32.7229 33.8362 32.4431 34.1532C32.1634 34.4702 31.8077 34.7111 31.4096 34.8533C31.0114 34.9955 30.5836 35.0343 30.1663 34.9663C29.749 34.8982 29.3558 34.7254 29.0234 34.4641L24.7672 31.25H15.2359L10.9766 34.4641C10.6442 34.7254 10.251 34.8982 9.83367 34.9663C9.41637 35.0343 8.98863 34.9955 8.59044 34.8533C8.19225 34.7111 7.83663 34.4702 7.55685 34.1532C7.27706 33.8362 7.08225 33.4534 6.99062 33.0406L5.05937 24.3484C4.97745 23.9754 4.98159 23.5886 5.07148 23.2175C5.16136 22.8463 5.33463 22.5005 5.57812 22.2062L10.0406 16.8531C10.1904 14.8858 10.642 12.9533 11.3797 11.1234C13.3953 6.07031 17.0047 2.9 18.4687 1.77187C18.907 1.43231 19.4456 1.24805 20 1.24805C20.5544 1.24805 21.093 1.43231 21.5312 1.77187C22.9906 2.9 26.6047 6.07031 28.6203 11.1234C29.358 12.9533 29.8096 14.8858 29.9594 16.8531L34.4219 22.2062C34.6654 22.5005 34.8386 22.8463 34.9285 23.2175C35.0184 23.5886 35.0225 23.9754 34.9406 24.3484ZM15.5359 28.75H24.4641C27.7641 22.8844 28.3812 17.2687 26.2984 12.05C24.4609 7.44375 21.0141 4.53125 20 3.75C18.9828 4.53125 15.5359 7.44375 13.6984 12.05C11.6187 17.2687 12.2359 22.8844 15.5359 28.75ZM13.1922 29.6641C11.5099 26.6068 10.4891 23.6021 10.1297 20.65L7.5 23.8062L9.43125 32.5L9.45937 32.4797L13.1922 29.6641ZM32.5 23.8062L29.8703 20.65C29.5141 23.5958 28.4953 26.6005 26.8141 29.6641L30.5406 32.4766L30.5687 32.4969L32.5 23.8062Z"
                    fill="#FF4E2B"
                  ></path>
                </svg>
              </span></center>

              <div>
                <p className={homeClasses.paraMission}>
                  At SapidBooks, our mission is to simplify the complexities of
                  accounting and financial management for businesses of all
                  sizes. We strive to provide a user-friendly platform that
                  combines cutting-edge technology with intuitive design,
                  allowing you to focus on what matters most - growing your
                  business.
                </p>
              </div>
            </div>
            <div className="col-md-4 col-12 col-lg-4">
              <div>
                <div>
                  <center><span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        d="M38.6422 19.4938C38.5875 19.3703 37.264 16.4344 34.3219 13.4922C30.4015 9.57187 25.45 7.5 20 7.5C14.55 7.5 9.59842 9.57187 5.67811 13.4922C2.73592 16.4344 1.40624 19.375 1.3578 19.4938C1.28672 19.6536 1.25 19.8266 1.25 20.0016C1.25 20.1765 1.28672 20.3495 1.3578 20.5094C1.41249 20.6328 2.73592 23.5672 5.67811 26.5094C9.59842 30.4281 14.55 32.5 20 32.5C25.45 32.5 30.4015 30.4281 34.3219 26.5094C37.264 23.5672 38.5875 20.6328 38.6422 20.5094C38.7132 20.3495 38.75 20.1765 38.75 20.0016C38.75 19.8266 38.7132 19.6536 38.6422 19.4938ZM20 30C15.1906 30 10.989 28.2516 7.51092 24.8047C6.08381 23.3855 4.86965 21.7671 3.90623 20C4.86939 18.2327 6.08357 16.6143 7.51092 15.1953C10.989 11.7484 15.1906 10 20 10C24.8094 10 29.0109 11.7484 32.489 15.1953C33.9189 16.614 35.1357 18.2324 36.1015 20C34.975 22.1031 30.0672 30 20 30ZM20 12.5C18.5166 12.5 17.0666 12.9399 15.8332 13.764C14.5998 14.5881 13.6385 15.7594 13.0709 17.1299C12.5032 18.5003 12.3547 20.0083 12.6441 21.4632C12.9335 22.918 13.6478 24.2544 14.6967 25.3033C15.7456 26.3522 17.0819 27.0665 18.5368 27.3559C19.9917 27.6453 21.4997 27.4968 22.8701 26.9291C24.2406 26.3614 25.4119 25.4001 26.236 24.1668C27.0601 22.9334 27.5 21.4834 27.5 20C27.4979 18.0115 26.7071 16.1051 25.301 14.699C23.8949 13.2929 21.9885 12.5021 20 12.5ZM20 25C19.0111 25 18.0444 24.7068 17.2221 24.1573C16.3999 23.6079 15.759 22.827 15.3806 21.9134C15.0021 20.9998 14.9031 19.9945 15.0961 19.0245C15.289 18.0546 15.7652 17.1637 16.4644 16.4645C17.1637 15.7652 18.0546 15.289 19.0245 15.0961C19.9944 14.9031 20.9998 15.0022 21.9134 15.3806C22.827 15.759 23.6079 16.3999 24.1573 17.2221C24.7067 18.0444 25 19.0111 25 20C25 21.3261 24.4732 22.5979 23.5355 23.5355C22.5978 24.4732 21.3261 25 20 25Z"
                        fill="#FF4E2B"
                      ></path>
                    </svg>{" "}
                  </span></center>
                </div>
                <div>
                  <p className={homeClasses.paraMission}>
                    We are a team of passionate professionals with diverse
                    expertise in accounting, technology, and user experience.
                    Our collective experience drives us to continuously enhance
                    our platform, ensuring that it aligns with the evolving
                    needs of modern businesses.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-12 col-lg-4">
              <div>
                <center><span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                  >
                    <path
                      d="M18.1516 16.7344C18.6422 17.2238 19.3069 17.4987 20 17.4987C20.693 17.4987 21.3578 17.2238 21.8484 16.7344L26.7344 11.8469C26.9771 11.6043 27.1696 11.3162 27.3009 10.9992C27.4323 10.6822 27.4999 10.3424 27.4999 9.99922C27.4999 9.65606 27.4323 9.31626 27.3009 8.99923C27.1696 8.68221 26.9771 8.39417 26.7344 8.15156L21.8484 3.26406C21.3578 2.77458 20.693 2.49969 20 2.49969C19.3069 2.49969 18.6422 2.77458 18.1516 3.26406L13.2656 8.15156C13.0229 8.39417 12.8304 8.68221 12.6991 8.99923C12.5677 9.31626 12.5001 9.65606 12.5001 9.99922C12.5001 10.3424 12.5677 10.6822 12.6991 10.9992C12.8304 11.3162 13.0229 11.6043 13.2656 11.8469L18.1516 16.7344ZM15.0266 9.91875L19.9141 5.03281C19.9348 5.0122 19.9629 5.00064 19.9922 5.00064C20.0215 5.00064 20.0495 5.0122 20.0703 5.03281L24.9578 9.91875C24.9774 9.94007 24.9882 9.96795 24.9882 9.99687C24.9882 10.0258 24.9774 10.0537 24.9578 10.075L20.0797 14.9672C20.0587 14.9874 20.0307 14.9987 20.0016 14.9987C19.9724 14.9987 19.9444 14.9874 19.9234 14.9672L15.0328 10.0797C15.0119 10.0581 15.0002 10.0293 15.0002 9.99922C15.0002 9.96918 15.0119 9.94032 15.0328 9.91875H15.0266ZM36.7297 18.1516L31.8484 13.2641C31.3581 12.7747 30.6936 12.4998 30.0008 12.4998C29.308 12.4998 28.6435 12.7747 28.1531 13.2641L23.2656 18.1516C22.7761 18.6422 22.5013 19.3069 22.5013 20C22.5013 20.693 22.7761 21.3578 23.2656 21.8484L28.1531 26.7359C28.6435 27.2253 29.308 27.5002 30.0008 27.5002C30.6936 27.5002 31.3581 27.2253 31.8484 26.7359L36.7359 21.8484C37.2254 21.3578 37.5003 20.693 37.5003 20C37.5003 19.3069 37.2254 18.6422 36.7359 18.1516H36.7297ZM34.9687 20.0797L30.0812 24.9672C30.0599 24.9867 30.032 24.9976 30.0031 24.9976C29.9742 24.9976 29.9463 24.9867 29.925 24.9672L25.0375 20.0797C25.0173 20.0587 25.0059 20.0307 25.0059 20.0016C25.0059 19.9724 25.0173 19.9444 25.0375 19.9234L29.925 15.0359C29.9463 15.0164 29.9742 15.0055 30.0031 15.0055C30.032 15.0055 30.0599 15.0164 30.0812 15.0359L34.9687 19.9234C34.989 19.9444 35.0003 19.9724 35.0003 20.0016C35.0003 20.0307 34.989 20.0587 34.9687 20.0797ZM16.7344 18.1516L11.8469 13.2641C11.3565 12.7747 10.692 12.4998 9.99922 12.4998C9.30643 12.4998 8.64193 12.7747 8.15156 13.2641L3.26406 18.1516C2.77458 18.6422 2.49969 19.3069 2.49969 20C2.49969 20.693 2.77458 21.3578 3.26406 21.8484L8.15156 26.7359C8.64193 27.2253 9.30643 27.5002 9.99922 27.5002C10.692 27.5002 11.3565 27.2253 11.8469 26.7359L16.7344 21.8484C17.2238 21.3578 17.4987 20.693 17.4987 20C17.4987 19.3069 17.2238 18.6422 16.7344 18.1516ZM14.9672 20.0797L10.0797 24.9672C10.0584 24.9867 10.0305 24.9976 10.0016 24.9976C9.97263 24.9976 9.94476 24.9867 9.92343 24.9672L5.03125 20.0797C5.01101 20.0587 4.9997 20.0307 4.9997 20.0016C4.9997 19.9724 5.01101 19.9444 5.03125 19.9234L9.91875 15.0328C9.94007 15.0133 9.96795 15.0024 9.99687 15.0024C10.0258 15.0024 10.0537 15.0133 10.075 15.0328L14.9625 19.9203C14.9733 19.9304 14.982 19.9426 14.9881 19.9561C14.9942 19.9696 14.9975 19.9842 14.9979 19.999C14.9984 20.0138 14.9959 20.0286 14.9906 20.0424C14.9853 20.0563 14.9774 20.0689 14.9672 20.0797ZM21.8422 23.2656C21.3515 22.7761 20.6868 22.5013 19.9937 22.5013C19.3007 22.5013 18.6359 22.7761 18.1453 23.2656L13.2656 28.1531C13.0229 28.3957 12.8304 28.6838 12.6991 29.0008C12.5677 29.3178 12.5001 29.6576 12.5001 30.0008C12.5001 30.3439 12.5677 30.6837 12.6991 31.0008C12.8304 31.3178 13.0229 31.6058 13.2656 31.8484L18.1516 36.7359C18.6422 37.2254 19.3069 37.5003 20 37.5003C20.693 37.5003 21.3578 37.2254 21.8484 36.7359L26.7344 31.8484C26.9771 31.6058 27.1696 31.3178 27.3009 31.0008C27.4323 30.6837 27.4999 30.3439 27.4999 30.0008C27.4999 29.6576 27.4323 29.3178 27.3009 29.0008C27.1696 28.6838 26.9771 28.3957 26.7344 28.1531L21.8422 23.2656ZM24.9672 30.0812L20.0797 34.9672C20.0589 34.9878 20.0308 34.9994 20.0016 34.9994C19.9723 34.9994 19.9442 34.9878 19.9234 34.9672L15.0328 30.0812C15.0133 30.0599 15.0024 30.032 15.0024 30.0031C15.0024 29.9742 15.0133 29.9463 15.0328 29.925L19.9203 25.0375C19.9413 25.0173 19.9693 25.0059 19.9984 25.0059C20.0276 25.0059 20.0556 25.0173 20.0766 25.0375L24.9641 29.925C24.984 29.9459 24.9954 29.9736 24.996 30.0025C24.9966 30.0314 24.9863 30.0595 24.9672 30.0812Z"
                      fill="#FF4E2B"
                    ></path>
                  </svg>{" "}
                </span></center>
              </div>
              <div>
                <p className={homeClasses.paraMission}>
                  Join us on our journey to simplify accounting and financial
                  management. Whether you're a small business owner, an
                  entrepreneur, or a finance professional, SapidBooks is here to
                  empower you with the tools you need to succeed.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container p-4">
        <h2 className={mainclasses.headingOrange}>What We Offer</h2>
        <div className="row">
          <div className="col-md-3 col-12 col-lg-3">
            <div className={homeClasses.carddesign}>
              <div className={homeClasses.cardbox}>
                <img
                  src={process.env.PUBLIC_URL + "/images/user-centric.png"}
                  alt=""
                  className={homeClasses.icon}
                />
                <h2>User-Centric Approach</h2>
                <p>
                  Our platform is designed with your needs in mind. We
                  understand the challenges you face, and we're committed to
                  creating a seamless experience that empowers you to manage
                  your finances efficiently.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-12 col-lg-3">
            <div className={homeClasses.carddesign}>
              <div className={homeClasses.cardbox}>
                <img
                  src={process.env.PUBLIC_URL + "/images/innovative-tool.png"}
                  alt=""
                  className={homeClasses.icon}
                />
                <h2>Innovative Tools</h2>
                <p>
                  We leverage the latest advancements in technology to provide
                  you with innovative accounting tools that simplify complex
                  processes, automate tasks, and provide real-time insights into
                  your financial health.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-12 col-lg-3">
            <div className={homeClasses.carddesign}>
              <div className={homeClasses.cardbox}>
                <img
                  src={process.env.PUBLIC_URL + "/images/data-security.png"}
                  alt=""
                  className={homeClasses.icon}
                />
                <h2>Data Security</h2>
                <p>
                  We prioritize the security of your sensitive financial
                  information. Our robust security measures and encryption
                  protocols ensure that your data remains safe and confidential.
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-12 col-lg-3">
            <div className={homeClasses.carddesign}>
              <div className={homeClasses.cardbox}>
                <img
                  src={process.env.PUBLIC_URL + "/images/continuous-improvement.png"}
                  alt=""
                  className={homeClasses.icon}
                />
                <h2>Continuous Improvement</h2>
                <p>
                  We're dedicated to continuous improvement. Our team listens to
                  your feedback and incorporates your suggestions to refine our
                  platform, making it even more user-friendly and effective.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
